import faker from 'faker';
import PropTypes from 'prop-types';
import { formatDistance } from 'date-fns';
import { zhTW } from 'date-fns/locale';

import { Link as RouterLink } from 'react-router-dom';
// material
import { Box, Stack, Link, Card, Typography, CardHeader } from '@mui/material';
// utils

//
import Scrollbar from '../../../presentation/components/Scrollbar';

// ----------------------------------------------------------------------

const NEWS = [...Array(10)].map((_, index) => ({
  title: 'rrr',
  description: 'ee',
  postedAt: faker.date.soon()
}));

// ----------------------------------------------------------------------

NewsItem.propTypes = {
  news: PropTypes.object.isRequired
};

function NewsItem({ news }) {
  const { sendCode, apiName, speed, time, name, fleet } = news;
  const utcDate = new Date(time);
  const taipeiTime = utcDate;

  const timespan = formatDistance(taipeiTime, new Date(), {
    locale: zhTW,
    addSuffix: true
  });
  return (
    <Stack direction="row" alignItems="center" spacing={2}>
      <Box sx={{ minWidth: 240 }}>
        <Link to="#" color="inherit" underline="hover" component={RouterLink}>
          <Typography variant="subtitle2" noWrap>
            個案:{name} 車牌:{sendCode}
          </Typography>
        </Link>
        <Typography variant="body2" sx={{ color: 'text.secondary' }} noWrap>
          營運單位:{fleet}
        </Typography>
        <Typography variant="body2" sx={{ color: 'text.secondary' }} noWrap>
          發生事件:{apiName}
        </Typography>
        <Typography variant="body2" sx={{ color: 'text.secondary' }} noWrap>
          速度:{speed}
        </Typography>
      </Box>
      <Typography variant="caption" sx={{ pr: 3, flexShrink: 0, color: 'text.secondary' }}>
        {timespan}
      </Typography>
    </Stack>
  );
}

AppNewsUpdate.propTypes = {
  event: PropTypes.array
};

AppNewsUpdate.defaultProps = {
  event: []
};

export default function AppNewsUpdate(props) {
  const { event } = props;

  return (
    <Card sx={{ height: '480px', display: 'flex', flexDirection: 'column' }}>
      <CardHeader title="LINE即時訊息監控" />
      <Scrollbar>
        <Stack spacing={2} sx={{ p: 3, pr: 0 }}>
          {event.map((news) => (
            <NewsItem key={news.identifier} news={news} />
          ))}
        </Stack>
      </Scrollbar>
    </Card>
  );
}
